import { render, staticRenderFns } from "./LotTypeModal.vue?vue&type=template&id=9fff3e98&scoped=true"
import script from "./LotTypeModal.vue?vue&type=script&lang=js"
export * from "./LotTypeModal.vue?vue&type=script&lang=js"
import style0 from "./LotTypeModal.vue?vue&type=style&index=0&id=9fff3e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fff3e98",
  null
  
)

export default component.exports